import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const message = ref('')
  const type = ref<'success' | 'error' | null>(null)
  const status = ref(false)
  const timer = ref<null | ReturnType<typeof setTimeout>>(null)

  const set = ({ message: msg, type: toastType = 'success', time = 2000 }: { message: string; type?: 'success' | 'error'; time?: number }) => {
    if (timer.value) {
      clearTimeout(timer.value)
    }
    status.value = true
    message.value = msg
    type.value = toastType
    timer.value = setTimeout(() => {
      reset()
    }, time)
  }

  const reset = () => {
    status.value = false
    clearTimeout(timer.value as any)
    message.value = ''
    type.value = null
  }

  return {
    message,
    type,
    status,
    set,
    reset
  }
})
